/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
export var accessKey = {
    parameterPath: [
        "options",
        "accessKey"
    ],
    mapper: {
        serializedName: "accessKey",
        type: {
            name: "String"
        }
    }
};
export var articleIds = {
    parameterPath: [
        "options",
        "articleIds"
    ],
    mapper: {
        serializedName: "articleIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var articleType = {
    parameterPath: [
        "options",
        "articleType"
    ],
    mapper: {
        serializedName: "articleType",
        defaultValue: 'BeautyEdit',
        type: {
            name: "String"
        }
    }
};
export var atpClusterId = {
    parameterPath: [
        "options",
        "atpClusterId"
    ],
    mapper: {
        serializedName: "atpClusterId",
        type: {
            name: "Number"
        }
    }
};
export var bannerIds = {
    parameterPath: [
        "options",
        "bannerIds"
    ],
    mapper: {
        serializedName: "bannerIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var brand = {
    parameterPath: "brand",
    mapper: {
        required: true,
        serializedName: "brand",
        type: {
            name: "String"
        }
    }
};
export var brandId = {
    parameterPath: "brandId",
    mapper: {
        required: true,
        serializedName: "brandId",
        type: {
            name: "String"
        }
    }
};
export var catalogueId = {
    parameterPath: "catalogueId",
    mapper: {
        required: true,
        serializedName: "catalogueId",
        type: {
            name: "String"
        }
    }
};
export var categories = {
    parameterPath: [
        "options",
        "categories"
    ],
    mapper: {
        serializedName: "categories",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var category = {
    parameterPath: "category",
    mapper: {
        required: true,
        serializedName: "category",
        type: {
            name: "String"
        }
    }
};
export var categoryId0 = {
    parameterPath: [
        "options",
        "categoryId"
    ],
    mapper: {
        serializedName: "categoryId",
        type: {
            name: "String"
        }
    }
};
export var categoryId1 = {
    parameterPath: "categoryId",
    mapper: {
        required: true,
        serializedName: "categoryId",
        type: {
            name: "Uuid"
        }
    }
};
export var channel0 = {
    parameterPath: [
        "options",
        "channel"
    ],
    mapper: {
        serializedName: "channel",
        defaultValue: 'Web',
        type: {
            name: "String"
        }
    }
};
export var channel1 = {
    parameterPath: "channel",
    mapper: {
        required: true,
        serializedName: "channel",
        type: {
            name: "String"
        }
    }
};
export var clientApplication = {
    parameterPath: [
        "options",
        "clientApplication"
    ],
    mapper: {
        serializedName: "clientApplication",
        type: {
            name: "String"
        }
    }
};
export var codeStartsWith = {
    parameterPath: [
        "options",
        "codeStartsWith"
    ],
    mapper: {
        serializedName: "codeStartsWith",
        type: {
            name: "String"
        }
    }
};
export var conceptCode = {
    parameterPath: "conceptCode",
    mapper: {
        required: true,
        serializedName: "conceptCode",
        type: {
            name: "String"
        }
    }
};
export var conceptCodes0 = {
    parameterPath: [
        "options",
        "conceptCodes"
    ],
    mapper: {
        serializedName: "conceptCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var conceptCodes1 = {
    parameterPath: "conceptCodes",
    mapper: {
        required: true,
        serializedName: "conceptCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var conceptLabelDomains = {
    parameterPath: [
        "options",
        "conceptLabelDomains"
    ],
    mapper: {
        serializedName: "conceptLabelDomains",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var consultantNumber = {
    parameterPath: "consultantNumber",
    mapper: {
        required: true,
        serializedName: "consultantNumber",
        type: {
            name: "Number"
        }
    }
};
export var customerCategory = {
    parameterPath: [
        "options",
        "customerCategory"
    ],
    mapper: {
        serializedName: "customerCategory",
        type: {
            name: "String"
        }
    }
};
export var customerTypeId0 = {
    parameterPath: [
        "options",
        "customerTypeId"
    ],
    mapper: {
        serializedName: "customerTypeId",
        type: {
            name: "Number"
        }
    }
};
export var customerTypeId1 = {
    parameterPath: [
        "options",
        "customerTypeId"
    ],
    mapper: {
        serializedName: "customerTypeId",
        type: {
            name: "String"
        }
    }
};
export var depth = {
    parameterPath: [
        "options",
        "depth"
    ],
    mapper: {
        serializedName: "depth",
        defaultValue: -1,
        type: {
            name: "Number"
        }
    }
};
export var eCatalogueId = {
    parameterPath: "eCatalogueId",
    mapper: {
        required: true,
        serializedName: "eCatalogueId",
        type: {
            name: "String"
        }
    }
};
export var editorialPageIds = {
    parameterPath: [
        "options",
        "editorialPageIds"
    ],
    mapper: {
        serializedName: "editorialPageIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var excludeChildren = {
    parameterPath: [
        "options",
        "excludeChildren"
    ],
    mapper: {
        serializedName: "excludeChildren",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var externalCampaignUrls = {
    parameterPath: [
        "options",
        "externalCampaignUrls"
    ],
    mapper: {
        serializedName: "externalCampaignUrls",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var facetField = {
    parameterPath: [
        "options",
        "facetField"
    ],
    mapper: {
        serializedName: "facetField",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var filterParams = {
    parameterPath: [
        "options",
        "filterParams"
    ],
    mapper: {
        serializedName: "filterParams",
        type: {
            name: "String"
        }
    }
};
export var headerIds = {
    parameterPath: [
        "options",
        "headerIds"
    ],
    mapper: {
        serializedName: "headerIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var id = {
    parameterPath: "id",
    mapper: {
        required: true,
        serializedName: "id",
        type: {
            name: "String"
        }
    }
};
export var imageInfoId = {
    parameterPath: "imageInfoId",
    mapper: {
        required: true,
        serializedName: "imageInfoId",
        type: {
            name: "Uuid"
        }
    }
};
export var includedProducts = {
    parameterPath: [
        "options",
        "includedProducts"
    ],
    mapper: {
        serializedName: "includedProducts",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var includeIndexedText = {
    parameterPath: [
        "options",
        "includeIndexedText"
    ],
    mapper: {
        serializedName: "includeIndexedText",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var ingredientName = {
    parameterPath: "ingredientName",
    mapper: {
        required: true,
        serializedName: "ingredientName",
        type: {
            name: "String"
        }
    }
};
export var ingredientNames = {
    parameterPath: [
        "options",
        "ingredientNames"
    ],
    mapper: {
        serializedName: "ingredientNames",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var invite = {
    parameterPath: [
        "options",
        "invite"
    ],
    mapper: {
        serializedName: "invite",
        type: {
            name: "String"
        }
    }
};
export var isConsultantsOnly = {
    parameterPath: [
        "options",
        "isConsultantsOnly"
    ],
    mapper: {
        serializedName: "isConsultantsOnly",
        type: {
            name: "Boolean"
        }
    }
};
export var isSample = {
    parameterPath: [
        "options",
        "isSample"
    ],
    mapper: {
        serializedName: "isSample",
        type: {
            name: "Boolean"
        }
    }
};
export var isUserAuthenticated = {
    parameterPath: [
        "options",
        "isUserAuthenticated"
    ],
    mapper: {
        serializedName: "isUserAuthenticated",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var itemCodes = {
    parameterPath: [
        "options",
        "itemCodes"
    ],
    mapper: {
        serializedName: "itemCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var itemType = {
    parameterPath: [
        "options",
        "itemType"
    ],
    mapper: {
        serializedName: "itemType",
        type: {
            name: "String"
        }
    }
};
export var keys = {
    parameterPath: "keys",
    mapper: {
        required: true,
        serializedName: "keys",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var lang0 = {
    parameterPath: [
        "options",
        "lang"
    ],
    mapper: {
        serializedName: "lang",
        type: {
            name: "String"
        }
    }
};
export var lang1 = {
    parameterPath: "lang",
    mapper: {
        required: true,
        serializedName: "lang",
        type: {
            name: "String"
        }
    }
};
export var lookbookBannerIds = {
    parameterPath: [
        "options",
        "lookbookBannerIds"
    ],
    mapper: {
        serializedName: "lookbookBannerIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var lookbookEditorialArticlesCarouselIds = {
    parameterPath: [
        "options",
        "lookbookEditorialArticlesCarouselIds"
    ],
    mapper: {
        serializedName: "lookbookEditorialArticlesCarouselIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var lookbookIds = {
    parameterPath: [
        "options",
        "lookbookIds"
    ],
    mapper: {
        serializedName: "lookbookIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var lookbookProductBoxCarouselIds = {
    parameterPath: [
        "options",
        "lookbookProductBoxCarouselIds"
    ],
    mapper: {
        serializedName: "lookbookProductBoxCarouselIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var manufacturerIds = {
    parameterPath: [
        "options",
        "manufacturerIds"
    ],
    mapper: {
        serializedName: "manufacturerIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var navigationType = {
    parameterPath: "navigationType",
    mapper: {
        required: true,
        serializedName: "navigationType",
        type: {
            name: "String"
        }
    }
};
export var nodeId = {
    parameterPath: [
        "options",
        "nodeId"
    ],
    mapper: {
        serializedName: "nodeId",
        type: {
            name: "String"
        }
    }
};
export var olapicIds = {
    parameterPath: [
        "options",
        "olapicIds"
    ],
    mapper: {
        serializedName: "olapicIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var olapicType = {
    parameterPath: [
        "options",
        "olapicType"
    ],
    mapper: {
        serializedName: "olapicType",
        defaultValue: 'FrontPage',
        type: {
            name: "String"
        }
    }
};
export var orderId = {
    parameterPath: "orderId",
    mapper: {
        required: true,
        serializedName: "orderId",
        type: {
            name: "Number"
        }
    }
};
export var page = {
    parameterPath: [
        "options",
        "page"
    ],
    mapper: {
        serializedName: "page",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var pageId = {
    parameterPath: [
        "options",
        "pageId"
    ],
    mapper: {
        serializedName: "pageId",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var pageUrl = {
    parameterPath: [
        "options",
        "pageUrl"
    ],
    mapper: {
        serializedName: "pageUrl",
        type: {
            name: "String"
        }
    }
};
export var periodId = {
    parameterPath: [
        "options",
        "periodId"
    ],
    mapper: {
        serializedName: "periodId",
        type: {
            name: "Number"
        }
    }
};
export var productBoxCarouselIds = {
    parameterPath: [
        "options",
        "productBoxCarouselIds"
    ],
    mapper: {
        serializedName: "productBoxCarouselIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productCode0 = {
    parameterPath: "productCode",
    mapper: {
        required: true,
        serializedName: "productCode",
        type: {
            name: "String"
        }
    }
};
export var productCode1 = {
    parameterPath: [
        "options",
        "productCode"
    ],
    mapper: {
        serializedName: "productCode",
        type: {
            name: "String"
        }
    }
};
export var productCodes0 = {
    parameterPath: [
        "options",
        "productCodes"
    ],
    mapper: {
        serializedName: "productCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productCodes1 = {
    parameterPath: "productCodes",
    mapper: {
        required: true,
        serializedName: "productCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productLabelDomains = {
    parameterPath: [
        "options",
        "productLabelDomains"
    ],
    mapper: {
        serializedName: "productLabelDomains",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var promotionTypes = {
    parameterPath: [
        "options",
        "promotionTypes"
    ],
    mapper: {
        serializedName: "promotionTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var query = {
    parameterPath: "query",
    mapper: {
        required: true,
        serializedName: "query",
        type: {
            name: "String"
        }
    }
};
export var registrationType = {
    parameterPath: "registrationType",
    mapper: {
        required: true,
        serializedName: "registrationType",
        type: {
            name: "String"
        }
    }
};
export var relatedArticlesUrls = {
    parameterPath: [
        "options",
        "relatedArticlesUrls"
    ],
    mapper: {
        serializedName: "relatedArticlesUrls",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var relatedCategory = {
    parameterPath: "relatedCategory",
    mapper: {
        required: true,
        serializedName: "relatedCategory",
        type: {
            name: "String"
        }
    }
};
export var relationTypes = {
    parameterPath: [
        "options",
        "relationTypes"
    ],
    mapper: {
        serializedName: "relationTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var skip0 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "skip",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var skip1 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "skip",
        type: {
            name: "Number"
        }
    }
};
export var skip2 = {
    parameterPath: "skip",
    mapper: {
        required: true,
        serializedName: "skip",
        type: {
            name: "Number"
        }
    }
};
export var skipEmpty = {
    parameterPath: [
        "options",
        "skipEmpty"
    ],
    mapper: {
        serializedName: "skipEmpty",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var sort = {
    parameterPath: [
        "options",
        "sort"
    ],
    mapper: {
        serializedName: "sort",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var storename = {
    parameterPath: [
        "options",
        "storename"
    ],
    mapper: {
        serializedName: "storename",
        type: {
            name: "String"
        }
    }
};
export var take = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 10,
        type: {
            name: "Number"
        }
    }
};
export var tenant = {
    parameterPath: "tenant",
    mapper: {
        required: true,
        serializedName: "tenant",
        type: {
            name: "String"
        }
    }
};
export var termId = {
    parameterPath: "termId",
    mapper: {
        required: true,
        serializedName: "termId",
        type: {
            name: "String"
        }
    }
};
export var top0 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 100,
        type: {
            name: "Number"
        }
    }
};
export var top1 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        type: {
            name: "Number"
        }
    }
};
export var top2 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 10,
        type: {
            name: "Number"
        }
    }
};
export var top3 = {
    parameterPath: "top",
    mapper: {
        required: true,
        serializedName: "top",
        type: {
            name: "Number"
        }
    }
};
export var top4 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var type = {
    parameterPath: [
        "options",
        "type"
    ],
    mapper: {
        serializedName: "type",
        type: {
            name: "String"
        }
    }
};
export var typeCode = {
    parameterPath: [
        "options",
        "typeCode"
    ],
    mapper: {
        serializedName: "typeCode",
        type: {
            name: "String"
        }
    }
};
export var url = {
    parameterPath: [
        "options",
        "url"
    ],
    mapper: {
        serializedName: "url",
        type: {
            name: "String"
        }
    }
};
export var usePascalCaseResponseFormat = {
    parameterPath: [
        "options",
        "usePascalCaseResponseFormat"
    ],
    mapper: {
        serializedName: "usePascalCaseResponseFormat",
        type: {
            name: "Boolean"
        }
    }
};
export var useProductService = {
    parameterPath: [
        "options",
        "useProductService"
    ],
    mapper: {
        serializedName: "useProductService",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var userSegment = {
    parameterPath: [
        "options",
        "userSegment"
    ],
    mapper: {
        serializedName: "userSegment",
        type: {
            name: "String"
        }
    }
};
export var visitorSegment0 = {
    parameterPath: [
        "options",
        "visitorSegment"
    ],
    mapper: {
        serializedName: "visitorSegment",
        type: {
            name: "String"
        }
    }
};
export var visitorSegment1 = {
    parameterPath: [
        "options",
        "visitorSegment"
    ],
    mapper: {
        serializedName: "visitorSegment",
        defaultValue: 'NotDefined',
        type: {
            name: "String"
        }
    }
};
export var warehouseId = {
    parameterPath: [
        "options",
        "warehouseId"
    ],
    mapper: {
        serializedName: "warehouseId",
        type: {
            name: "Number"
        }
    }
};

//# sourceMappingURL=parameters.js.map
